import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IDepartmentList4DashboardResponse,
  ActionType,
} from "models/dashboard/departmentList";
import { httpStatus } from "configs/httpStatus";
import { fetchDepartmentList } from "services/dashboard";
import { handleSuccesAction, handleErrorAction } from "./departmentListActions";

function* getDepartmentList4DashboardSaga() {
  try {
    const response: IDepartmentList4DashboardResponse = yield call(
      fetchDepartmentList
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetDepartmentListWatcher() {
  yield takeLatest(
    ActionType.GET_DEPARTMENT_LIST_4_DASHBOARD as any,
    getDepartmentList4DashboardSaga
  );
}

export default [fork(onGetDepartmentListWatcher)];
